
import LayoutBase from "@/common/LayoutBase";

export default {
  extends: LayoutBase,
};
